function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAxe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 499.64 499.64",
    style: {
      enableBackground: "new 0 0 499.64 499.64"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABA45"
    },
    d: "M301.149,424.051H23.287c76.877-55.251,88.364-190.866,88.364-190.866h255.39   c0,0,11.486,135.615,88.364,190.866H321.151"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E95B2D"
    },
    d: "M168.678,233.185h81.204c24.143-12.473,40.391-34.543,40.391-54.116   c-15.615-8.431-26.399-19.68-26.399-49.488V75.589H209.28h-54.594v53.991c0,29.808-10.784,41.058-26.398,49.488   C128.288,198.642,144.534,220.712,168.678,233.185z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.288,
    y: 75.589,
    style: {
      fill: "#FABA45"
    },
    width: 26.399,
    height: 35.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.873,
    y: 75.589,
    style: {
      fill: "#FABA45"
    },
    width: 228.267,
    height: 35.972
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F2639"
    },
    d: "M100.599,391.344c22.748-42.027,34.32-87.985,40.022-119.138l-14.754-2.701   c-5.507,30.085-16.649,74.404-38.46,114.699L100.599,391.344z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.526,
    y: 335.047,
    style: {
      fill: "#0F2639"
    },
    width: 15,
    height: 20.854
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F2639"
    },
    d: "M499.64,119.061V68.089H271.373h-15h-94.187h-15h-26.398v50.972h26.398v10.52   c0,28.408-10.625,36.497-22.462,42.889l-3.937,2.126v4.474c0,16.133,9.091,33.181,23.946,46.616H104.76l-0.582,6.867   c-0.027,0.331-2.944,33.565-15.052,73.153C78.075,341.836,56.924,390.64,18.91,417.96L0,431.551h301.149v-15H43.924   c25.401-24.46,45.387-60.163,59.546-106.458c9.393-30.713,13.423-57.326,14.91-69.407h48.475h14.49v134.492h15V240.685h11.512   v74.11h15v-74.11h28.849h75.821v74.11h15v-74.11h17.786c1.487,12.081,5.516,38.694,14.909,69.407   c14.159,46.296,34.145,81.998,59.547,106.458H321.151v15h157.541l-18.91-13.59c-37.938-27.266-59.075-75.935-70.127-111.962   c-12.152-39.62-15.112-73.115-15.141-73.446l-0.582-6.867H273.825c14.857-13.436,23.947-30.484,23.947-46.616v-4.474l-3.936-2.125   c-11.838-6.391-22.463-14.48-22.463-42.889v-10.52H499.64z M271.373,83.089H484.64v20.972H271.373V83.089z M135.788,104.061V83.089   h11.398v20.972H135.788z M282.478,183.248c-2.127,15.409-15.634,32.192-34.461,42.437h-77.476   c-18.826-10.245-32.333-27.028-34.46-42.437c14.039-8.559,26.104-21.922,26.104-53.667v-10.52V83.089h94.187v35.972v10.52   C256.373,161.326,268.439,174.689,282.478,183.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F2639"
    },
    d: "M244.792,185.725c-3.26,3.804-15.454,16.214-35.512,16.214c-20.059,0-32.254-12.411-35.513-16.214   l-4.881-5.695l-11.39,9.761l4.88,5.695c4.314,5.033,20.442,21.454,46.903,21.454c26.46,0,42.589-16.421,46.902-21.454l4.88-5.695   l-11.39-9.761L244.792,185.725z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxe);
export default __webpack_public_path__ + "static/media/axe.84745d9e.svg";
export { ForwardRef as ReactComponent };